<script>
	import Card from "./Card.svelte";
	import data from "./index.json";
</script>

<main>
	<div class="grid-container">
		{#each data.articles as article}
			{#if article.visible === "true"}
				<Card
					title={article.title}
					description={article.description}
					url={article.url}
					img={article.img}
				/>
			{/if}
		{/each}
	</div>
</main>

<style>
	main {
		font-family: "Ubuntu Mono";
		color: #3e454f;
		background-color: #f9f9f9;
		padding: 5px;
	}

	.grid-container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
		grid-gap: 20px;
	}
</style>
